import styled from 'styled-components';
import { Dialog } from 'cdk-radial';

export const StyledSessionTimeoutDialog = styled(Dialog)`
  width: 0px;
`;
